import { useState } from 'react';
import { Truck } from 'lucide-react';
import { WinchPricingCalculator } from '@/components/winch/WinchPricingCalculator';
import { WinchPricingCalculatorEnhanced } from '@/components/winch/WinchPricingCalculatorEnhanced';
import { WinchPricingManagement } from '@/components/winch/WinchPricingManagement';
import { useAuth } from '@/hooks';

/**
 * WinchPricingPage Component
 * Main page for winch distance-based pricing
 * Shows calculator for all users and management view for managers
 */
export const WinchPricingPage = () => {
  const { hasRole } = useAuth();
  const [activeTab, setActiveTab] = useState<'distance' | 'regions' | 'management'>('regions');
  const isManager = hasRole('manager');

  return (
    <div className="space-y-6" dir="rtl">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Truck className="h-8 w-8 text-primary" />
          <h1 className="text-2xl font-bold text-primary">أسعار خدمة الونش</h1>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="card">
        <div className="flex gap-4">
          <button
            onClick={() => setActiveTab('regions')}
            className={`px-6 py-3 rounded-md font-medium transition-colors ${
              activeTab === 'regions'
                ? 'bg-primary text-dark shadow-glow'
                : 'text-gray-400 hover:text-gray-200 hover:bg-dark-lighter'
            }`}
          >
            🗺️ حسب المناطق
          </button>
          <button
            onClick={() => setActiveTab('distance')}
            className={`px-6 py-3 rounded-md font-medium transition-colors ${
              activeTab === 'distance'
                ? 'bg-primary text-dark shadow-glow'
                : 'text-gray-400 hover:text-gray-200 hover:bg-dark-lighter'
            }`}
          >
            📏 حسب المسافة
          </button>
          {isManager && (
            <button
              onClick={() => setActiveTab('management')}
              className={`px-6 py-3 rounded-md font-medium transition-colors ${
                activeTab === 'management'
                  ? 'bg-primary text-dark shadow-glow'
                  : 'text-gray-400 hover:text-gray-200 hover:bg-dark-lighter'
              }`}
            >
              📊 الإدارة
            </button>
          )}
        </div>
      </div>

      {/* Content */}
      {activeTab === 'regions' ? (
        <WinchPricingCalculatorEnhanced />
      ) : activeTab === 'distance' ? (
        <WinchPricingCalculator />
      ) : (
        <WinchPricingManagement />
      )}
    </div>
  );
};

export default WinchPricingPage;
